/*
 * Copyright (c) 2017-2026 Brighter AI Technologies GmbH. All rights reserved.
 * Unauthorized use, copying, reproduction, or distribution of this file, via any medium,
 * is strictly prohibited.
 */

import React, { Suspense } from 'react';
import { useDataProvider } from 'ra-core'
import { useState, useEffect } from 'react'
import { Voting } from './Feedback/Voting'
import * as hotjarUtils from "../../commons/hotjarUtils"
import { useLocation } from 'react-router-dom'
const ThankYou = React.lazy(() => import('./Feedback/ThankYou'))

const NpsPopup = () => {
  const location = useLocation();
  const dataProvider = useDataProvider();
  const [isFeedbackOpen, setIsFeedbackOpen] = useState(false);
  const [isVoted, setIsVoted] = useState(false);

  useEffect(() => {
    let pollForUsage;
    let checkAndHideHotjar;
    // if we are on the survey, have not voted, and the hotjar survey exists
    if (location.hash === "#npssurvey" && !isVoted) {
      checkAndHideHotjar = setInterval(() => {
        if (hotjarUtils.hideWidgetContainer())
          clearInterval(checkAndHideHotjar);
      }, 500);

      pollForUsage = setInterval(() => {
        if (!hotjarUtils.isSurveyAvailable()) return;
        dataProvider
          .getList("usage", {
            pagination: {}, // all params must be populated to avoid errors
            sort: {},
            order: {},
            filter: {
              // get any usage in the past day
              date_gte: new Date().toDateString(),
              date_lte: new Date().toDateString(),
            },
          })
          .then((response) => {
            const { blur, dnat } = response.data[0];
            var totalFiles =
              blur.files_video +
              blur.files_image +
              dnat.files_video +
              dnat.files_image;
            // if there is more than 0 jobs in the past day
            if (totalFiles) {
              setIsFeedbackOpen(true);
              clearInterval(pollForUsage);
            }
          })
          .catch(() => {
            clearInterval(pollForUsage);
          });
      }, 10000);
    } else {
      clearInterval(pollForUsage);
      clearInterval(checkAndHideHotjar);
    }

    return function cleanUp() {
      clearInterval(pollForUsage);
      clearInterval(checkAndHideHotjar);
    };
  }, [dataProvider, location, isVoted]);

  return (
    <div>
      {isFeedbackOpen ? (
        isVoted ? (
          <Suspense fallback={<div>Loading...</div>}>
          <ThankYou
            open={isFeedbackOpen}
            setIsFeedbackOpen={setIsFeedbackOpen}
          />
          </Suspense>
        ) : (
          <Voting
            open={isFeedbackOpen}
            setIsVoted={setIsVoted}
            onClose={() => setIsFeedbackOpen(false)}
          />
        )
      ) : (
        <div />
      )}
    </div>
  );
};

export { NpsPopup };
